import * as React from "react";
import { cn } from "./utils";
import { type LucideIcon } from "lucide-react";

export interface FormInfoRowProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: LucideIcon;
    label: string;
    value: React.ReactNode;
    iconClassName?: string;
}

const FormInfoRow = React.forwardRef<HTMLDivElement, FormInfoRowProps>(
    ({ className, icon: Icon, label, value, iconClassName, ...props }, ref) => {
        return (
            <div ref={ref} className={cn("flex justify-between items-center", className)} {...props}>
                <div className="flex items-center gap-2">
                    {Icon && <Icon className={cn("w-4 h-4 text-slate-500", iconClassName)} />}
                    <span className="font-medium text-slate-600 text-sm">{label}:</span>
                </div>
                <div className="text-sm">{value}</div>
            </div>
        );
    }
);

FormInfoRow.displayName = "FormInfoRow";

export { FormInfoRow };
